// extracted by mini-css-extract-plugin
export default {"label":"Navbar_label__vhm6K"};